// This file was auto-generated by Fern from our API Definition.
export const EventType = {
    Unknown: "unknown",
    WebhooksSubscriptionsTested: "webhooks.subscriptions.tested",
    GatewaysCalled: "gateways.called",
    TracesFetched: "traces.fetched",
    TracesQueried: "traces.queried",
    QueriesRevisionsRetrieved: "queries.revisions.retrieved",
    QueriesRevisionsFetched: "queries.revisions.fetched",
    QueriesRevisionsQueried: "queries.revisions.queried",
    QueriesRevisionsLogged: "queries.revisions.logged",
    QueriesRevisionsCommitted: "queries.revisions.committed",
    TestcasesFetched: "testcases.fetched",
    TestcasesQueried: "testcases.queried",
    TestsetsRevisionsRetrieved: "testsets.revisions.retrieved",
    TestsetsRevisionsFetched: "testsets.revisions.fetched",
    TestsetsRevisionsQueried: "testsets.revisions.queried",
    TestsetsRevisionsLogged: "testsets.revisions.logged",
    TestsetsRevisionsCommitted: "testsets.revisions.committed",
    WorkflowsRevisionsRetrieved: "workflows.revisions.retrieved",
    WorkflowsRevisionsFetched: "workflows.revisions.fetched",
    WorkflowsRevisionsQueried: "workflows.revisions.queried",
    WorkflowsRevisionsLogged: "workflows.revisions.logged",
    WorkflowsRevisionsCommitted: "workflows.revisions.committed",
    EnvironmentsRevisionsRetrieved: "environments.revisions.retrieved",
    EnvironmentsRevisionsFetched: "environments.revisions.fetched",
    EnvironmentsRevisionsQueried: "environments.revisions.queried",
    EnvironmentsRevisionsLogged: "environments.revisions.logged",
    EnvironmentsRevisionsCommitted: "environments.revisions.committed",
};
